angular
  .module('deskfy.core')
  .controller('InputAttachmentController', InputAttachmentController)

/* @ngInject */
function InputAttachmentController ($scope, $timeout, $translate, $q, Utils, AssetPreviewService, BriefingService, NewAssetService, AssetService, CONSTANTS, UploadService, ToastService, BackendErrorParserService, UdsModalService) {
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))

  let taskId = null
  $scope.selected = []
  $scope.attachments = []
  $scope.field.loadingFiles = 0

  $scope.formatSize = Utils.getReadableFileSizeString

  $scope.rename = BriefingService.updateFieldValue
  $scope.downloadWithProgress = BriefingService.downloadWithProgress

  $scope.attActions = {
    download: downloadAttachment,
    downloadWithProgress: $scope.downloadWithProgress,
    update: $scope.rename,
    delete: disattach.bind($scope)
  }

  $scope.loading = false

  const api = {
    _checkForLinks
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._checkForLinks()

    const previewAssets = JSON.parse(JSON.stringify($scope.field.field_values || '')) // this will avoid circular structure error
    $scope.attachments = []
    $scope.files = $scope.files || $scope.field.value || []
    $scope.files = $scope.files.filter(file => file.metadata).map(file => {
      if (!taskId && file.taskId) {
        taskId = file.taskId
      }

      if ($scope.attachments.indexOf(file.value) === -1) {
        $scope.attachments.push(file.value)
      }

      return angular.extend(file, {
        id: file.value,
        name: file.metadata.name,
        size: file.metadata.size,
        src: {
          original: AssetService.getDownloadAssetUrl(file.value),
          default: AssetService.getAssetThumbnailByType(file.metadata.type),
          thumbnail: NewAssetService.getAssetThumbnailUrl(file.value, 'LOW')
        },
        contentType: file.metadata.contentType,
        type: file.metadata.type,
        extension: file.metadata.extension,
        previewAssets
      })
    }, $scope)

    $scope.field.value = $scope.attachments
  }

  $scope.$watch('field.clearAttachments', (newValue) => {
    if (newValue) {
      $scope.attachments = []
      $scope.files = []
      $scope.field.clearAttachments = false
    }
  })

  $scope.openAttachAssetsDialog = () => {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents'
        },
        onClose: async (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }
          $scope.field.loadingFiles = assetsToAttach.length

          for await (const asset of assetsToAttach) {
            const assetRawData = await NewAssetService.getAssetDetails(asset.id, { formatData: 'raw' })

            $scope.files.push(assetRawData)
            $scope.attachments.push(asset.id) // this array is used to set the value to be saved in the form field
          }

          $timeout(() => {
            $scope.field.loadingFiles = 0
            $scope.field.value = $scope.attachments
          }, 1000)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.attach = files => {
    if (!files.length) {
      return
    }

    $scope.loading = true
    $scope.field.loadingFiles += files.length
    UploadService.uploadMultipleFileToS3(files, {
      onUploadProgress: (file, progress) => {
        if (progress < 100) {
          return
        }

        $timeout(() => {
          $scope.field.loadingFiles--
          $scope.onChange()
        })
      }
    })
      .then((uploadedAssets) => {
        $timeout(() => {
          uploadedAssets.forEach((asset) => {
            $scope.files.push(asset)
            $scope.attachments.push(asset.id) // this array is used to set the value to be saved in the form field
          })

          $scope.field.loadingFiles = 0
          $scope.onCompleteFile()
        })
      }).catch(error => {
        console.error(error)
        $scope.loading = false

        if (BackendErrorParserService.isInvalidFileError(error)) {
          ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
          $timeout(() => {
            $scope.field.loadingFiles = 0
          })
        }
      })
  }

  function disattach (assetId) {
    const uploadedFileIndex = $scope.attachments.findIndex(file => file === assetId)
    const finishedUpload = !isNaN(uploadedFileIndex)
    const removeAssetFromArray = () => {
      $timeout(() => {
        $scope.attachments.splice(uploadedFileIndex, 1)
        if (!finishedUpload) {
          $scope.field.loadingFiles--
        }

        $scope.onCompleteFile()
      })
    }

    removeAssetFromArray()
  }

  $scope.openPreview = function (index) {
    AssetService.getAssetDetailsById($scope.attachments[index])
      .then((assetDetails) => {
        AssetPreviewService.openAssetPreview({
          asset: assetDetails,
          location: $scope.location,
          getPreviewAssets: () => {
            const assetsPromises = $scope.attachments.map((attachmentId) => {
              return AssetService.getAssetDetailsById(attachmentId)
            })

            return Promise.all(assetsPromises)
              .then((assetsDetails) => {
                return {
                  count: assetsDetails.length,
                  assets: assetsDetails
                }
              })
          }
        })
      })
  }

  $scope.onCompleteFile = function () {
    $scope.field.value = $scope.attachments
    $scope.loading = false
    $scope.onComplete()
  }

  $scope.$onChanges = changes => {
    if (changes.field && changes.field.currentValue.value != null) {
      this.files = null
      activate()
    } else if (typeof changes.field === 'undefined' && this.files !== null) {
      activate()
    }
  }

  function downloadAttachment (attachment) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [attachment.id])

    if ($scope.location) {
      const downloadModule = AssetPreviewService.getModuleForLocation($scope.location)
      url = Utils.fnAddQueryToUrl(url, { downloadModule })
    }

    Utils.downloadFile(url)
  }

  function _checkForLinks () {
    const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
    $scope.labelWithLinks = result[0]
    $scope.descriptionWithLinks = result[1]
  }
}
